import script from "./signable-documents-filter-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./signable-documents-filter-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__